import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import styled from "styled-components";
// import { Consumer } from "../../context";

export default class Product extends Component {
    render() {
        const { id, title, img, price, inCart } = this.props.product;
        const { handleDetail, handleCart, openModal, closeModal } = this.props;
        return (
            <ProductWrapper className="col-9 mx-auto col-md-6 col-lg-3 my-3">
                <div className="card">
                    <div
                        className="img-container p-5"
                        onClick={handleDetail.bind(this, id)}
                    >
                        <Link to="/details">
                            <img
                                src={img}
                                alt={title}
                                className="card-img-top"
                            />
                        </Link>
                        <button
                            className="btn cart-btn btn-info"
                            disabled={inCart}
                            onClick={() => {
                                handleCart(id);
                                openModal(id);
                            }}
                        >
                            {inCart ? (
                                <p className="text-capitalize mb-0" disabled>
                                    {" "}
                                    in Cart
                                </p>
                            ) : (
                                <i className="fas fa-cart-plus" />
                            )}
                        </button>
                    </div>
                    <div className="card-footer d-flex justify-content-between">
                        <p className="align-self-center mb-0">{title}</p>
                        <h5 className="text-primary font-italic mb-0">
                            <span className="mr-1">$</span> {price}
                        </h5>
                    </div>
                </div>
            </ProductWrapper>
        );
    }
}

Product.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        img: PropTypes.string,
        price: PropTypes.number,
        inCart: PropTypes.bool
    }).isRequired
};

const ProductWrapper = styled.div`
    .card {
        border-color: tranparent;
        transition: all 1s linear;
    }
    .card-footer {
        transition: all 1s linear;
    }
    &:hover {
        .card {
            border: 0.04rem solid rgba(0, 0, 0, 0.3);
            box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.6);
        }
    }
    .img-container {
        position: relative;
        overflow: hidden;
    }
    .card-img-top {
        transition: all 1s linear;
    }
    .img-container:hover .card-img-top {
        transform: scale(1.2);
    }

    .cart-btn {
        position: absolute;
        right: 0;
        bottom: 0;
        border-radius: 0.5rem 0 0 0;
        transition: all 1s linear;
        transform: translate(100%, 100%);
    }
    .img-container:hover .cart-btn {
        transform: translate(0%, 0%);
    }
    .cart-btn:hover {
        color: #000;
    }
`;
